import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import img12ft from '../assets/12ft1.jpg';
import img20ft from '../assets/20ft1.jpg';
import img40ft from '../assets/40ft1.jpg';
import imgShutter from '../assets/shutter1.jpg';
import imgNew from '../assets/shinpinkakou.jpg';
import imgUsed from '../assets/chuko1.jpg';

function Types() {
  const sectionRef = useRef(null);
  const gridRef = useRef(null);

  const containerData = [
    {
      title: '10ft',
      img: img12ft, // TODO: 10ft専用画像が追加されたら差し替える
      text: '小スペース向けの小型サイズ。',
      category: 'size',
      slug: '10ft'
    },
    {
      title: '12ft',
      img: img12ft,
      text: '省スペースで使いやすいサイズ。',
      category: 'size',
      slug: '12ft'
    },
    {
      title: '20ft',
      img: img20ft,
      text: '定番サイズで幅広い用途に対応。',
      category: 'size',
      slug: '20ft'
    },
    {
      title: '40ft',
      img: img40ft,
      text: '大容量の保管・事務所利用に。',
      category: 'size',
      slug: '40ft'
    },
    {
      title: 'シャッター付き',
      img: imgShutter,
      text: '出し入れしやすい人気タイプ。',
      category: 'other',
    },
    {
      title: 'オーダー加工仕様',
      img: imgNew,
      text: '用途に合わせた開口部や内装施工など、ご希望に応じたオーダー加工に対応。',
      category: 'other',
    },
    {
      title: '中古コンテナ',
      img: imgUsed,
      text: 'コストを抑えたい方に。',
      category: 'other',
    }
    
  ];

  useEffect(() => {
    const section = sectionRef.current;
    const grid = gridRef.current;

    if (!section || !grid) return undefined;

    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!mediaQuery.matches || reducedMotion.matches || !('IntersectionObserver' in window)) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        grid.classList.add('is-swipe-hint');
        observer.disconnect();
      },
      {
        threshold: 0.58,
        rootMargin: '0px 0px -12% 0px',
      }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
    };
  }, []);

  const sizeItems = containerData.filter((item) => item.category === 'size');
  const otherItems = containerData.filter((item) => item.category === 'other');

  const renderCard = (item, index) => (
    <article
      className={`type-card ${item.slug ? 'type-card--size' : 'type-card--other'}`}
      key={`${item.title}-${index}`}
    >
      <div className="type-card__image">
        <img src={item.img} alt={item.title} />
      </div>

      <div className="type-card__body">
        <div className="type-card__title-row">
          <h3 className="type-card__title">
            {item.slug ? item.title.toUpperCase() : item.title}
          </h3>
          {item.slug && (
            <div className="type-card__badges" aria-label="対応状態">
              <span className="type-card__badge type-card__badge--new">新品対応</span>
              <span className="type-card__badge type-card__badge--used">中古対応</span>
            </div>
          )}
        </div>
        {item.slug && <p className="type-card__text">{item.text}</p>}
        {item.slug && (
          <Link to={`/containers/${item.slug}`} className="type-card__link">
            VIEW DETAIL <span aria-hidden="true">-&gt;</span>
          </Link>
        )}
      </div>
    </article>
  );

  return (
    <section className="section types-section" id="types" ref={sectionRef}>
      <div className="container">
        <div className="section-head reveal">
          <p className="section-label">CONTAINER TYPE</p>
          <h2 className="section-title">タイプ別</h2>
          <p className="section-desc">
            用途やサイズに合わせて、さまざまなタイプのコンテナをご提案します。
          </p>
        </div>

        <div className="types-list" ref={gridRef}>
          {sizeItems.length > 0 && (
            <div className="types-grid types-grid--size">
              {sizeItems.map(renderCard)}
            </div>
          )}

          {otherItems.length > 0 && (
            <div className="types-group types-group--other">
              <p className="types-group__label">OTHER TYPES</p>
              <div className="types-grid types-grid--other">
                {otherItems.map(renderCard)}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Types;
